module.exports = __webpack_public_path__ + "img/ar.d205ca13.svg";